import { Component, Optional } from '@angular/core';
import { SocketClientService } from './services/socket-client.service';
import { SESSION_TYPE, SessionService } from './services/session.service';
import {
     IAccessControlValidation,
     ILoginObRes,
     ILoginRes,
     ISession,
} from '../typings';
import { SessionPrepareService } from './services/session-prepare.service';
import { Router } from '@angular/router';
import { WsService } from './services/ws/ws.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorDialogService } from './services/error-dialog.service';
import { SpinnerMessageService } from './services/spinner-message.service';
import { InteractionService } from './services/interaction.service';
import { LogoutService } from './services/logout.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from './services/data.service';
import { BootstrapSessionService } from './services/bootstrap-session';
import { ToastrService } from 'ngx-toastr';

moment.locale(window.app.lang._.moment);

@Component({
     selector: 'app-root',
     templateUrl: './app.component.html',
     styleUrls: ['./app.component.scss'],
})
export class AppComponent {
     spinnerMessage$;
     isTvScreen: boolean;
     constructor(
          @Optional() private socket: SocketClientService,
          private session: SessionService,
          private sessionPrepare: SessionPrepareService,
          private ws: WsService,
          private spinner: NgxSpinnerService,
          private router: Router,
          private spinnerMessage: SpinnerMessageService,
          private errorDialog: ErrorDialogService,
          private interaction: InteractionService,
          private dialog: MatDialog,
          private data: DataService,
          private toastr: ToastrService,
          private bootstrapSession: BootstrapSessionService,
          private logout: LogoutService
     ) {
          const bodyBgImage = window.app.conf.ui.coverImage;
          if (bodyBgImage) {
               const body = document.body;
               body.style.backgroundImage =
                    'url(' + window.app.conf.ui.coverImage + ')';
          }

          this.interaction.start();
          this.interaction.disconnect$.subscribe(() => {
               this.logout.run();
          });

          let clearTimerId = null;
          const clearSession = () => {
               this.interaction.reset();
               // 1. Clear existing memory session
               this.session.clear();

               // 2. Update to new session
               this.router.navigateByUrl('/');

               // 3. Clear memory data
               this.data.clear();

               this.dialog.closeAll();
               // 4. Clear popup outlet
               if (clearTimerId) {
                    clearTimeout(clearTimerId);
                    clearTimerId = null;
               }
               clearTimerId = setTimeout(() => {
                    this.router.navigate([{ outlets: { popup: null } }]);
               }, 10);
          };
          const isDiconnected = false;
          this.spinnerMessage$ = this.spinnerMessage.message$;
          // http://reactivex.io/rxjs/class/es6/Observable.js~Observable.html#static-method-webSocket
          this.socket?.socket$.subscribe(async (data: any) => {
               try {
                    if (data.action === 'DISCONNECTED_BY_NEW_INSTANCE') {
                         this.socket.close();
                         clearSession();
                         this.router.navigateByUrl('/disconnected');
                         this.interaction.reset();
                         this.interaction.stop();
                    } else if (data.action === 'INSTANT_PLANNING_CARD_LOGIN') {
                         clearSession();
                         setTimeout(async () => {
                              try {
                                   if (data.body) {
                                        this.spinnerMessage.reset();
                                        this.spinner.show();
                                        let external = data.body.external;
                                        let res1: ILoginObRes, res2: ILoginRes;
                                        let validationResult: IAccessControlValidation;
                                        validationResult =
                                             data.body.validationResult;
                                        // External clients session returns more data than internal
                                        // So we need to handle responses differently
                                        if (external) {
                                             res1 = data.body
                                                  .session as ILoginObRes;
                                        } else {
                                             res2 = data.body
                                                  .session as ILoginRes;
                                             this.session.set(
                                                  {
                                                       idSession: res2.token,
                                                  } as ISession,
                                                  SESSION_TYPE.INTERNAL
                                             );
                                        }
                                        await this.sessionPrepare.run(
                                             external,
                                             res1,
                                             res2
                                        );
                                        try {
                                             this.spinner.hide();
                                             if (
                                                  validationResult &&
                                                  validationResult.authorized
                                             ) {
                                                  this.router.navigateByUrl(
                                                       '/app'
                                                  );
                                             } else {
                                                  this.errorDialog.openErrorDialog(
                                                       session.get(),
                                                       'unauthorized'
                                                  );
                                             }
                                        } catch (err) {
                                             let timeout =
                                                  err &&
                                                  err.ctxCode === 'TIMEOUT'; // Check if it was a timeout erro
                                             this.errorDialog.openErrorDialog(
                                                  session.get(),
                                                  timeout
                                                       ? 'timeout'
                                                       : 'unexpected'
                                             );
                                        }
                                        this.bootstrapSession.run();
                                   }
                              } catch (err) {
                                   this.spinner.hide();
                                   this.toastr.error(
                                        window.appLang.GENERIC_ERROR_MSG +
                                             '. AUTH_KO'
                                   );
                              }
                         }, 200);
                    } else if (data.action === 'INSTANT_PLANNING_LOGOUT') {
                         clearSession();

                         setTimeout(() => {
                              this.router.navigate([
                                   { outlets: { popup: null } },
                              ]);
                         }, 10);
                    } else if (data.action === 'INSTANT_PLANNING_CONNECT') {
                         setTimeout(() => {
                              if (data.body && data.body.idSession) {
                                   this.session.set(
                                        data.body,
                                        data.body.sessionType
                                   );
                                   try {
                                        this.spinner.hide();
                                        this.router.navigateByUrl('/app');
                                   } catch (err) {
                                        const timeout =
                                             err && err.ctxCode === 'TIMEOUT'; // Check if it was a timeout erro
                                        this.errorDialog.openErrorDialog(
                                             session.get(),
                                             timeout ? 'timeout' : 'unexpected'
                                        );
                                   }
                              } else {
                                   this.session.clear();
                                   this.router.navigateByUrl('/');
                              }
                         }, 300);
                    }
               } catch (err) {
                    console.log(err);
               }
          });
     }
}
